<template>
  <div 
    ref="pageContent"
    class="w-full h-full overflow-y-scroll px-5">
    <div class="mx-auto px-4 sm:px-8 xl:px-0 mt-6 flex gap-6">
      <aside class="w-1/5 hidden lg:block">
        <h3 class="text-lg font-semibold mb-4">Категории</h3>
        <ul class="space-y-2">
          <li
            v-for="cat in categories"
            :key="cat.id"
            @click="selectCategory(cat.id)"
            class="cursor-pointer text-sm px-3 py-2 rounded hover:bg-gray-100"
            :class="{ 'bg-gray-200 font-medium': selectedCategory === cat.id }"
          >
            {{ cat.name }}
          </li>
          <li
            @click="selectCategory(null)"
            class="cursor-pointer text-sm px-3 py-2 rounded hover:bg-gray-100"
            :class="{ 'bg-gray-200 font-medium': selectedCategory === null }"
          >
            Все категории
          </li>
        </ul>
      </aside>

      <div class="flex-1">
        <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 mt-3 h-full">
          <div class="mb-12.5">
            <div class="flex justify-between items-center mb-6">
              <div class="text-center flex-1">
                <h2 class="text-dark mb-3.5 text-2xl font-bold sm:text-4xl xl:text-heading-3 mb-4">
                  <span v-if="contentTypeSaved == 'news'">Новости</span>
                  <span v-else-if="contentTypeSaved == 'law'">Законы</span>
                  <span v-else-if="contentTypeSaved == 'science'">Наука</span>
                  <span v-else-if="contentTypeSaved == 'contest'">Соревнованиях/Конкурсы/Турниры</span>
                  <span v-else-if="contentTypeSaved == 'uav_catalog'">Каталог продукции БПЛА</span>
                </h2>
              </div>
              <button
                v-if="isAuthenticated && ['news', 'science', 'contest', 'uav_catalog', 'law'].includes(contentTypeSaved) && (user.role && user.role.key !== 1)"
                @click="showSuggestForm = true"
                class="px-4 md:px-6 py-2 bg-gray-800 text-white rounded-xl hover:bg-gray-700 transition font-medium text-xs md:text-sm whitespace-nowrap ml-4"
              >
                <b>
                  <span v-if="contentTypeSaved == 'news'">Предложить новость</span>
                  <span v-else-if="contentTypeSaved == 'law'">Предложить закон</span>
                  <span v-else-if="contentTypeSaved == 'science'">Предложить статью</span>
                  <span v-else-if="contentTypeSaved == 'contest'">Предложить соревнование</span>
                  <span v-else-if="contentTypeSaved == 'uav_catalog'">Предложить продукт</span>
                </b>
              </button>
            </div>
          </div>

          <div v-if="contentList === null" class="text-center text-gray-500">
            Загружаем...
          </div>
          <div v-else-if="contentList.length === 0" class="text-center text-gray-500">
            Не найдено.
          </div>
          <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-11 gap-x-7.5 gap-3">
          <div v-for="item in contentList" :key="item.slug" class="group">
            <router-link 
              :to="{ name: 'PageContentDetail', params: { contentType: contentType, slug: item.slug } }"
              class="block group rounded-[10px] overflow-hidden hover:shadow-lg transition-all p-3"
            >
              <div class="mb-6 overflow-hidden rounded-[10px]">
                <div 
                  class="block w-full h-48 bg-cover bg-center"
                  :style="{ backgroundImage: `url(${item.image})` }">
                </div>
              </div>
              <h3>
                <span class="block text-dark font-bold text-xl mb-3.5 bg-linear-to-r from-primary/50 to-primary/40 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px]">
                  {{ item.title }}
                </span>
              </h3>
              <p v-html="item.content" class="line-clamp-3"></p>
              <div class="flex flex-wrap gap-3 items-center justify-between mt-4.5">
                <p class="text-sm">{{ item.created_at }}</p>
                <span class="inline-flex text-blue bg-blue/[0.08] font-medium text-sm py-1 px-3 rounded-full">
                  {{ item.category_name || 'News' }}
                </span>
              </div>
            </router-link>
          </div>
          </div>

          <div v-if="totalPages > 1" class="flex justify-center items-center mt-10 gap-2 flex-wrap ">
            <label class="mr-2 text-sm font-medium">Страница:</label>
            <select
              v-model.number="currentPage"
              @change="handlePageChange"
              style="width: 50px;"
              class="border px-3 py-2 rounded-md"
            >
              <option v-for="n in totalPages" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
            <span class="text-sm text-gray-600">Из {{ totalPages }}</span>
          </div>
        </div>
        <div class="pb-3"></div>
      </div>

    </div>

    <!-- Modal: Suggest Content -->
    <div v-if="showSuggestForm" class="fixed inset-0 bg-black bg-opacity-50 z-[10010] flex items-center justify-center p-4">
      <div class="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div class="sticky top-0 bg-white border-b p-6 flex justify-between items-center">
          <h2 class="text-2xl font-bold text-gray-900">
            <span v-if="contentTypeSaved == 'news'">Предложить новость</span>
            <span v-else-if="contentTypeSaved == 'law'">Предложить закон</span>
            <span v-else-if="contentTypeSaved == 'science'">Предложить статью (Наука)</span>
            <span v-else-if="contentTypeSaved == 'contest'">Предложить соревнование</span>
            <span v-else-if="contentTypeSaved == 'uav_catalog'">Предложить продукт</span>
          </h2>
          <button
            @click="showSuggestForm = false"
            class="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>

        <div class="p-6">
          <ContentSuggestForm
            :content-type="contentTypeSaved"
            @submit="handleSuggestSubmit"
            @close="showSuggestForm = false"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { API_CONTENT, API_CATEGORIES_CLIENT } from "@/const/uri";
import ContentSuggestForm from "@/components/PageContent/ContentSuggestForm.vue";
import { mapState } from 'vuex';

export default {
  name: "PageContent",
  components: {
    ContentSuggestForm,
  },
  data() {
    return {
      contentList: null,
      currentPage: 1,
      perPage: 9,
      totalPages: 1,
      contentTypeSaved: null,
      categories: [],
      selectedCategory: null,
      showSuggestForm: false,
      isAuthenticated: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    contentType() {
      return this.$route.params.contentType;
    },
    queryPage() {
      const p = parseInt(this.$route.query.p);
      console.log('p:', p);
      return isNaN(p) || p < 1 ? 1 : p;
    },
  },
  mounted() {
    this.checkAuthentication();
    this.fetchCategories();
  },
  watch: {
    '$route.query.p': {
      immediate: true,
      handler() {
        this.currentPage = this.queryPage;
        this.fetchContent();
      },
    },
    '$route.params.contentType': {
      immediate: true,
      handler() {
        this.contentTypeSaved = this.$route.params.contentType;
      }
    }
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await axios.get(
          API_CATEGORIES_CLIENT.base, 
          {
            params: {
              content_type: this.$route.params.contentType,
            },
          });
        if (res.data.code === 0) {
          this.categories = res.data.data;
        }
      } catch (error) {
        console.error("Ошибка загрузки категорий:", error);
      }
    },
    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
      this.currentPage = 1;
      this.updateRoutePage(1);
      this.fetchContent();
    },
    async fetchContent() {
      try {
        const response = await axios.get(API_CONTENT.list, {
          params: {
            content_type: this.contentType,
            p: this.currentPage,
            category: this.selectedCategory || undefined,
            page_size: this.perPage,
          },
        });

        if (response.data.code === 0) {
          const responseData = response.data.data;
          this.contentList = responseData.results;
          this.totalPages = Math.ceil(responseData.count / this.perPage);
        }
      } catch (error) {
        console.error("Ошибка загрузки контента:", error);
      }
    },
    handlePageChange() {
      this.updateRoutePage(this.currentPage);
    },
    updateRoutePage(page) {
      this.$router.push({
        path: `/page/${this.contentType}`,
        query: {
          ...this.$route.query,
          p: page,
        },
      });
    },
    checkAuthentication() {
      const token = localStorage.getItem('user_token');
      this.isAuthenticated = !!token;
    },
    handleSuggestSubmit() {
      this.showSuggestForm = false;
      this.fetchContent();
    },
  },
};
</script>
